import Plyr from 'plyr';

const videos = document.querySelectorAll('.js-plyr');
if (videos) {
    document.addEventListener('DOMContentLoaded', () => {
        const playerOptions = {
            ratio: '16:9'
        };
        for (let i = 0; i < videos.length; i++) {
            const player = new Plyr(videos[i], playerOptions);
            let controls;
            player.on('ready', (event) => {
                controls = event.detail.plyr.elements.controls;
                controls.style.opacity = 0;
            });
            player.once('playing', () => {
                controls.style.opacity = 1;
            });
        }
    });
}
